import { render, staticRenderFns } from "./UnionFieldList.vue?vue&type=template&id=2630acf0&scoped=true"
import script from "./UnionFieldList.vue?vue&type=script&lang=js"
export * from "./UnionFieldList.vue?vue&type=script&lang=js"
import style0 from "./UnionFieldList.vue?vue&type=style&index=0&id=2630acf0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2630acf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2630acf0')) {
      api.createRecord('2630acf0', component.options)
    } else {
      api.reload('2630acf0', component.options)
    }
    module.hot.accept("./UnionFieldList.vue?vue&type=template&id=2630acf0&scoped=true", function () {
      api.rerender('2630acf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionFieldList.vue"
export default component.exports